import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=d4b9a980&scoped=true&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"
import style0 from "./user-info.vue?vue&type=style&index=0&id=d4b9a980&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b9a980",
  null
  
)

export default component.exports